import { render, staticRenderFns } from "./new2.vue?vue&type=template&id=16128742&scoped=true"
import script from "./new2.vue?vue&type=script&lang=js"
export * from "./new2.vue?vue&type=script&lang=js"
import style0 from "./new2.vue?vue&type=style&index=0&id=16128742&prod&scoped=true&lang=css"
import style1 from "./new2.vue?vue&type=style&index=1&id=16128742&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16128742",
  null
  
)

export default component.exports